<template>
    <draggable
        @start="drag=true"
        @end="drag=false"
        :class="['totem-draggable', direction]"
        v-bind="$attrs"
        v-on="$listeners"
    >
       <slot />
    </draggable>
</template>

<script>
    import draggable from 'vuedraggable'

    export default {
        name: 'totem-draggable',
        components: {
            draggable
        },
        props: {
            draggableList: Array,
            direction: {
                type: String,
                default: 'horizontal',
                validator: (prop) => ['horizontal', 'vertical'].includes(prop)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .totem-draggable {
        display: flex;

        &.horizontal {
            flex-direction: column;
            flex-wrap: wrap;
            width: 100%;

            [class*="desktop"] & {
                flex-direction: row;
            }
        }
        &.vertical {
            flex-direction: column;
        }
    }
</style>
